import styled from 'styled-components'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-top: 2rem;

  .eyebrow {
    text-transform: uppercase;
    letter-spacing: 0.18rem;
    color: var(--muted);
    font-size: 1.2rem;
    font-weight: 600;
  }

  .name {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    line-height: 0.9;

    span {
      font-family: 'Rammetto One', cursive;
      font-size: clamp(3.6rem, 8vw, 5.8rem);
      letter-spacing: -0.05rem;
      color: var(--text);
      text-shadow: 0 14px 40px rgba(0, 0, 0, 0.35);
    }
  }

  .animated-line {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    font-size: clamp(1.6rem, 3vw, 2rem);
    font-weight: 600;
    margin-top: 0.4rem;
  }

  .ai-tag {
    color: var(--accent);
    letter-spacing: 0.08rem;
  }

  .typing {
    color: var(--text);
    min-height: 2.4rem;
  }

  .cursor {
    color: var(--muted);
    animation: blink 1s steps(2, start) infinite;
  }

  .lede {
    max-width: 68ch;
    color: var(--muted);
    font-size: 1.7rem;
  }

  .actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
    margin-top: 0.6rem;
  }

  .ghost {
    padding: 1rem 2.2rem;
    border-radius: 999px;
    border: 1px solid var(--border);
    background: var(--pill-bg);
    color: var(--text);
    font-weight: 600;
    transition: transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      background: var(--gradient);
      transform: translateY(-2px);
      box-shadow: 0 12px 36px rgba(0, 0, 0, 0.25);
    }
  }

  .social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
    margin-top: 0.5rem;

    a {
      width: 4.6rem;
      height: 4.6rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      border: 1px solid var(--border);
      background: var(--pill-bg);
      transition: transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;

      &:hover {
        background: var(--gradient);
        transform: translateY(-2px);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
      }

      img {
        width: 2.2rem;
        height: 2.2rem;
      }
    }
  }

  @keyframes blink {
    0%,
    50% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }

  @media (max-width: 640px) {
    gap: 1.2rem;

    .name {
      span {
        font-size: clamp(3.2rem, 9vw, 4.6rem);
      }
    }

    .lede {
      font-size: 1.6rem;
    }

    .actions {
      gap: 0.8rem;
    }

    .social-links {
      gap: 0.8rem;

      a {
        width: 4.2rem;
        height: 4.2rem;
      }
    }
  }
`
